import { render, staticRenderFns } from "./NotaExameEspecial-anterior.vue?vue&type=template&id=36a953e6&"
import script from "./NotaExameEspecial-anterior.vue?vue&type=script&lang=js&"
export * from "./NotaExameEspecial-anterior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports